






































































































































































































































    import {
        defineComponent,
        ref,
        computed,
        onMounted,
    } from "@vue/composition-api";
    import useMap from "@/utilities/useGoogleMaps";
    import { mobState, app, alarm } from "@/store/index";
    import useVIPContacts from "@/store/useVIPContacts";
    import VIPContactViewModel from "@/models/VIPContactViewModel";
    import { VueTelInput } from "vue-tel-input";
    import useVIPContact from "../store/useVIPContact";
  
    export default defineComponent({
        components: { 
            VueTelInput,
             LoadingDialog: () =>
                import(/* webpackChunkName: "settings" */ "./components/Dialogs/LoadingDialog.vue"),
        },
        setup(_, { root }) {
            const { VIPcontacts, getVIPContacts } = useVIPContacts();
            const { add, remove, update, get, nameRules } = useVIPContact();
            const contactForm = ref<HTMLFormElement>();
            const editContactForm = ref<HTMLFormElement>();
            const map = ref();
            const { googleMapApi } = useMap();
            const location = ref<GeolocationPosition>();
            let myGoogleMap: google.maps.Map;
            let poly: google.maps.Polyline;
            let userMarker: google.maps.Marker;
            let infoWindow: google.maps.InfoWindow;
            let user: google.maps.LatLng;
            const phoneInputRef = ref();
            const phone = ref<string>('');
            const showDialog = ref<boolean>(false);
            const showAddContactDialog = ref<boolean>(false);
            const showEditContactDialog = ref<boolean>(false);
            const name = ref<string>("");
            let editedContact: VIPContactViewModel;
            const errorMessage = ref<string>("");
            const isFetchingPosition = ref<boolean>(true);

            const user_lat = computed<number>(() => { return alarm.user_lat ? alarm.user_lat : 0; });

            const user_lng = computed<number>(() => { return alarm.user_lng ? alarm.user_lng : 0; });

            const latitude = computed<string>(() => {
                return user_lat.value != 0 ? user_lat.value.toFixed(6) : "-.--";
            });

            const longitude = computed<string>(() => {
                return user_lng.value != 0 ? user_lng.value.toFixed(6) : "-.--";
            });

            const latLetter = computed<string>(() => user_lat.value >= 0 ? "N" : "S");

            const lngLetter = computed<string>(() => user_lng.value >= 0 ? "E" : "W");

            const selectContact = (VIPcontact: VIPContactViewModel) => {
                vueTel.value.phone = VIPcontact.phoneNumber;
                closeContactDialog();
            };

            const showContactDialog = () => { showDialog.value = true; };

            const closeContactDialog = () => { showDialog.value = false; };

            const openAddContactDialog = () => { showAddContactDialog.value = true; };

            const closeAddContactDialog = () => { showAddContactDialog.value = false; };

            const openEditContactDialog = () => { showEditContactDialog.value = true; };

            const closeEditContactDialog = () => { showEditContactDialog.value = false; };

            const editVIPContact = (VIPcontact: VIPContactViewModel) => {
                name.value = VIPcontact.name;
                vueTel2.value.phone = VIPcontact.phoneNumber;
                editedContact = VIPcontact;
                openEditContactDialog();
            };

            const initEditSave = () => {
                if (editContactForm.value) {
                    editedContact.name = name.value;
                    editedContact.phoneNumber = vueTel2.value.phone;
                    update(editedContact).then(() => {
                        getVIPContacts();
                        name.value = "";
                        vueTel2.value.phone = '';
                        closeEditContactDialog();
                    });
                }
            }

            const initSave = () => {
                if (contactForm.value) {
                    const newContact = new VIPContactViewModel();
                    newContact.name = name.value;
                    newContact.phoneNumber = vueTel2.value.phone;
                    add(newContact).then(() => {
                        getVIPContacts();
                        name.value = "";
                        vueTel2.value.phone = '';
                        closeAddContactDialog();
                    });
                };
            };

            const deleteVIPContact = (VIPcontact: VIPContactViewModel) => {
                remove(VIPcontact.id).then(() => {
                    getVIPContacts();
                });
            };

            const requestUserPosition = () => {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        (position: GeolocationPosition) => {
                            handlePositionSuccess(position);
                        },
                        (error: GeolocationPositionError) => {
                            handlePositionError(error);
                        },
                        { enableHighAccuracy: true, maximumAge: 0 }
                    );
                } else {
                    errorMessage.value = "Geolocation is not supported by this browser.";
                    app.error = errorMessage.value;
                }
            };

            const handlePositionSuccess = (position: GeolocationPosition) => {

                alarm.SetUserLocation(position);

                location.value = position;

                user = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

                const path = poly.getPath();

                userMarker.setPosition(user);
                userMarker.setVisible(true);

                path.push(user);

                const contentString =
                    `
                        <h3 style="text-align:center"><strong>User position</strong></h3>

<p class="mb-0" style="text-align:center"><strong>Lat:</strong>&nbsp;${userMarker.getPosition().lat().toFixed(6)}<strong>&nbsp;&nbsp;|&nbsp; Lon: </strong>${userMarker.getPosition().lng().toFixed(6)}</p>
                    `;

                userMarker.addListener("click", () => {
                    infoWindow.close();
                    infoWindow.setContent(contentString);
                    infoWindow.open(userMarker.getMap(), userMarker);
                });
                isFetchingPosition.value = false;
                //removeGoogleFontsForMaps();

                myGoogleMap.setCenter(user);
            };

            const goToGeoPerm = () => {
                root.$router.push({ name: "geo-permission", params: { destination: "map" } });
            };

            const handlePositionError = (error: GeolocationPositionError) => {
                if (error.code === error.PERMISSION_DENIED) {
                    errorMessage.value = "User denied the request for geolocation.";
                } else if (error.code === error.POSITION_UNAVAILABLE) {
                    errorMessage.value = "Location information is unavailable.";
                } else if (error.code === error.TIMEOUT) {
                    errorMessage.value = "The request to get user location timed out.";
                } else {
                    errorMessage.value = "An unknown error occurred.";
                }
                app.error = errorMessage.value;
                goToGeoPerm();
            };

            const sendMobMessage = () => {
                if (latitude.value && longitude.value) {
                    const phoneData = phoneInputRef.value;
                    const number = phoneData.phoneObject ? phoneData.phoneObject.number : phone.value;
                    mobState
                        .sendMobMessage({
                            lat: latitude.value,
                            lng: longitude.value,
                            phone: number
                        })
                        .then(() => {
                            app.success = 'MOB message sent successfully.';
                        });
                }
            };

            const vueTel = ref({
                phone: '',
                props: {
                    autoFormat: true,
                    autoDefaultCountry: true,
                    dropdownOptions: {
                        showDialCodeInList: true,
                        showDialCodeInSelection: false,
                        showFlags: true,
                        showSearchBox: true,
                        width: '300px',
                    },
                    ignoredCountries: ['KP', 'RU'],
                    inputOptions: {
                        autocomplete: 'on',
                        showDialCode: true,
                        placeholder: 'Enter phone number',
                        required: true,
                    },
                    mode: 'international',
                    preferredCountries: ['DK', 'NO', 'SE'],
                    validCharactersOnly: true,
                },
            });

            const vueTel2 = ref({
                phone: '',
                props: {
                    autoFormat: true,
                    autoDefaultCountry: true,
                    dropdownOptions: {
                        showDialCodeInList: true,
                        showDialCodeInSelection: false,
                        showFlags: true,
                        showSearchBox: true,
                        width: '300px',
                    },
                    ignoredCountries: ['KP', 'RU'],
                    inputOptions: {
                        autocomplete: 'on',
                        showDialCode: true,
                        placeholder: 'Enter phone number',
                        required: true,
                    },
                    mode: 'international',
                    preferredCountries: ['DK', 'NO', 'SE'],
                    validCharactersOnly: true,
                },
            });

            //const removeGoogleFontsForMaps = () => {
            //    console.log("Removing Google Fonts for Google Maps");
            //    // Find and remove Google Fonts styles injected by Google Maps
            //    const googleFontsLinks = document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"][href*="fonts.googleapis.com"]');

            //    googleFontsLinks.forEach(link => {
            //        // iterate and console log the links found

            //        console.log("Checking link:");
            //        console.log(link.href);

            //        // Check if the link does not contain the fonts you want to keep
            //        if (!link.href.includes('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap')) {

            //            console.log("Removing link:");
            //            console.log(link.href);
            //            // Remove the link from the DOM
            //            link.remove();
            //        }
            //    });
            //};
            
            onMounted(async () => {
                googleMapApi.load().then(() => {
                    console.log("Google Maps API loaded");
                    const userPos = new google.maps.LatLng(user_lat.value, user_lng.value);
                    infoWindow = new google.maps.InfoWindow();
                    userMarker = new google.maps.Marker();

                    const userIcon = {
                        url: 'https://dsspoc.azurewebsites.net/img/icons/map-marker-user.svg',
                        scaledSize: new google.maps.Size(80, 80),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(40, 80)
                    };

                    myGoogleMap = new google.maps.Map(map.value, {
                        center: userPos,
                        mapTypeId: "satellite",
                        zoom: 16,
                        disableDefaultUI: true,
                        backgroundColor: "#000000",
                        zoomControl: false,
                        mapTypeControl: true,
                        mapTypeControlOptions: {
                            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
                        },
                        fullscreenControl: true
                    });

                    userMarker.setPosition(userPos);
                    userMarker.setMap(myGoogleMap);
                    userMarker.setIcon(userIcon);
                    userMarker.setTitle("You are here.");
                    userMarker.setVisible(true);

                    poly = new google.maps.Polyline({
                        strokeColor: "#FF0000",
                        strokeOpacity: 1.0,
                        strokeWeight: 2,
                        zIndex: 10,
                    });
                    poly.setMap(myGoogleMap);

                    myGoogleMap.setCenter(userMarker.getPosition() as google.maps.LatLng);
                });
            });

            return {
                phone,
                sendMobMessage,
                phoneInputRef,
                map,
                latitude,
                longitude,
                latLetter,
                lngLetter,
                showContactDialog,
                showDialog,
                closeContactDialog,
                VIPcontacts,
                selectContact,
                vueTel,
                vueTel2,
                openAddContactDialog,
                closeAddContactDialog,
                initSave,
                name,
                showAddContactDialog,
                contactForm,
                deleteVIPContact,
                showEditContactDialog,
                closeEditContactDialog,
                openEditContactDialog,
                editVIPContact,
                editContactForm,
                initEditSave,
                requestUserPosition,
                isFetchingPosition,
            };
        },
        created: function () {
            const timer = setInterval(() => { this.requestUserPosition(); }, 5000);

            this.$once("hook:beforeDestroy", () => {
                clearInterval(timer);
            });
        },
        data: () => ({
            isValid: false,
            isValid2: false,
        }),
        methods: {
            phoneObject: function (object) {
                if (object.valid === true) {
                    this.isValid = true;
                } else {
                    this.isValid = false;
                }
            },
            phoneObject2: function (object) {
                if (object.valid === true) {
                    this.isValid2 = true;
                } else {
                    this.isValid2 = false;
                }
            },
        }
    });
